// extracted by mini-css-extract-plugin
export const wrapper = "styles-module--wrapper--3duH0";
export const leftContainer = "styles-module--leftContainer--2X7QU";
export const homeLink = "styles-module--homeLink--B_niK";
export const rightContainer = "styles-module--rightContainer--38wbt";